export const translations = {
  id: {
    nav: {
      home: "Beranda",
      about: "Tentang",
      packages: "Paket",
      gallery: "Galeri",
      blog: "Blog",
      contact: "Kontak",
      book: "Daftar Sekarang",
    },
    common: {
      readMore: "Baca selengkapnya",
      learnMore: "Pelajari lebih lanjut",
      viewAll: "Lihat semua",
      viewDetails: "Lihat detail",
      bookNow: "Pesan Sekarang",
      send: "Kirim Pesan",
      sending: "Mengirim...",
      whatsapp: "Hubungi via WhatsApp",
      from: "Mulai dari",
      duration: "Durasi",
      departure: "Keberangkatan",
      inclusions: "Termasuk",
      highlights: "Sorotan Paket",
      backToPackages: "← Kembali ke semua paket",
      backToBlog: "← Kembali ke blog",
    },
    hero: {
      overline: "Perjalanan Suci yang Berkesan",
      titleA: "Tunaikan Ibadah",
      titleB: "Umrah & Haji",
      titleC: "dengan Hati Tenang",
      sub: "BATIK Tour & Travel mendampingi langkah suci Anda dengan layanan paripurna, hotel premium dekat Masjidil Haram & Masjid Nabawi, serta pembimbing ustadz berpengalaman.",
      cta1: "Lihat Paket Perjalanan",
      cta2: "Konsultasi Gratis",
      stat1: "Tahun Berdiri",
      stat2: "Jamaah Diberangkatkan",
      stat3: "Pemandu Bersertifikat",
      stat4: "Tingkat Kepuasan",
    },
    sections: {
      featuredOver: "Pilihan Unggulan",
      featuredTitle: "Paket Perjalanan Pilihan",
      featuredSub: "Beragam paket umrah dan haji yang dirancang dengan kekhusyukan dan kenyamanan.",
      aboutOver: "Tentang Kami",
      aboutTitle: "Mendampingi Tamu-Tamu Allah",
      aboutSub: "Sejak 2016, PT Baitullah Tiga Kharisma (BATIK Tour & Travel) mendampingi jamaah dengan amanah — resmi berizin PPIU & PIHK Kementerian Agama RI.",
      whyOver: "Mengapa BATIK",
      whyTitle: "Komitmen Kami untuk Anda",
      testiOver: "Suara Jamaah",
      testiTitle: "Pengalaman Tamu Allah",
      testiSub: "Kepercayaan ribuan jamaah adalah cermin pelayanan kami.",
      galleryOver: "Galeri Perjalanan",
      galleryTitle: "Momen Suci yang Terabadikan",
      gallerySub: "Setiap perjalanan menyimpan kisah ruhani yang tak terlupakan.",
      blogOver: "Cerita & Panduan",
      blogTitle: "Artikel Terbaru",
      blogSub: "Panduan, tips, dan kisah inspiratif seputar umrah dan haji.",
      ctaOver: "Siap Berangkat?",
      ctaTitle: "Mulai Perjalanan Ruhani Anda Hari Ini",
      ctaSub: "Tim kami siap membantu menemukan paket umrah atau haji yang paling sesuai untuk Anda dan keluarga.",
    },
    categories: {
      overline: "Layanan Kami",
      title: "Kategori Paket Menarik untuk Anda",
      sub: "Pilih layanan ibadah yang paling sesuai dengan kebutuhan Anda dan keluarga.",
    },
    fasilitas: {
      overline: "Fasilitas Jamaah",
      title: "Fasilitas Paket Umroh Batik Travel",
      sub: "Semua paket kami mencakup fasilitas lengkap agar Anda bisa fokus beribadah dengan tenang.",
    },
    ustadz: {
      overline: "Ustadz Pembimbing",
      title: "Ustadz Batik Travel",
      sub: "Ustadz-ustadz berpengalaman membimbing ibadah jamaah kami di Tanah Suci.",
    },
    why: {
      f1: "Resmi & Berizin",
      f1d: "Terdaftar resmi sebagai Penyelenggara Perjalanan Ibadah Umrah (PPIU) Kementerian Agama RI.",
      f2: "Pembimbing Berpengalaman",
      f2d: "Ustadz-ustadz bersertifikat dengan pengalaman membimbing lebih dari 10 tahun.",
      f3: "Hotel Premium",
      f3d: "Hotel berbintang dengan lokasi terdekat ke Masjidil Haram dan Masjid Nabawi.",
      f4: "Harga Transparan",
      f4d: "Tidak ada biaya tersembunyi — semua fasilitas tercantum jelas dalam kontrak.",
    },
    about: {
      hero: "Aman, Nyaman & Sesuai Tuntunan",
      heroSub: "PT Baitullah Tiga Kharisma (BATIK Tour & Travel) — travel Umroh & Haji Khusus berizin resmi PPIU & PIHK Kementerian Agama RI. Lebih dari 15.000+ jamaah telah kami dampingi dengan pengalaman ibadah yang berkesan dan bermakna.",
      storyTitle: "Tentang BATIK Travel",
      story1: "PT Baitullah Tiga Kharisma (BATIK Tour & Travel) adalah biro travel Umroh & Haji Khusus resmi yang siap mendampingi perjalanan ibadah Anda dengan aman, nyaman, dan sesuai tuntunan. Berdiri sejak 2016 sebagai Biro Perjalanan Wisata, pada 2020 kami memperoleh izin resmi PPIU melalui SK KMA RI No. U.565 Tahun 2020, lalu pada 2023 memperoleh izin PIHK — terakreditasi A oleh Kementerian Agama.",
      story2: "Lebih dari 15.000+ jamaah dari Indonesia dan luar negeri telah kami berangkatkan — sebuah bukti pengalaman dan kepercayaan jamaah dalam menjalankan ibadah bersama kami.",
      story3: "Kami meyakini perjalanan ibadah adalah perjalanan hati dan jiwa. Setiap program telah dipersiapkan matang: dari perlengkapan jamaah, itinerary yang terencana, hingga pendampingan ibadah oleh asatidzah dan muthawif berpengalaman — supaya Umroh Anda bersama BATIK terasa Berkesan dan Bermakna.",
      missionTitle: "Visi & Misi",
      visionTitle: "Visi",
      visionText: "Menjadi yang terdepan dalam memberikan pelayanan ibadah Umroh dan Haji sekaligus mendukung dakwah Islam — biro perjalanan resmi & terpercaya yang mengantarkan setiap muslim ke Baitullah dengan pelayanan profesional, amanah, dan sesuai syariat.",
      missionT: "Misi",
      mission1: "Menghadirkan legalitas resmi PPIU & PIHK dengan tiket & jadwal keberangkatan yang confirmed",
      mission2: "Memberikan kenyamanan mulai dari pendaftaran hingga kepulangan — akomodasi, konsumsi, transportasi terjamin",
      mission3: "Membimbing jamaah menjalankan ibadah sesuai tuntunan Rasulullah ﷺ oleh ustadz dan muthawif berpengalaman",
      mission4: "Menyalurkan sebagian hasil usaha untuk dakwah, pendidikan Islam, dan kegiatan sosial",
      valuesTitle: "Nilai Kami",
      v1: "Aman",
      v1d: "Legalitas resmi PPIU & PIHK, pengurusan visa umroh & haji khusus, alur keberangkatan yang jelas.",
      v2: "Nyaman",
      v2d: "Akomodasi hotel terbaik, konsumsi terjamin, transportasi nyaman, perlengkapan ibadah lengkap.",
      v3: "Sesuai Tuntunan",
      v3d: "Bimbingan ustadz asatidzah dan muthawif yang memastikan setiap prosesi ibadah sesuai tuntunan.",
      v4: "Berpengalaman",
      v4d: "Lebih dari 15.000+ jamaah telah kami berangkatkan dari seluruh Indonesia dan luar negeri.",
      // Fasilitas Jamaah (from ptbatik.co.id)
      facilitiesOver: "Fasilitas Jamaah",
      facilitiesTitle: "Fasilitas untuk Jamaah",
      facilitiesSub: "Fasilitas yang dirancang untuk memberikan kenyamanan, keamanan, dan kemudahan bagi jamaah selama di Tanah Suci.",
    },
    packages: {
      title: "Paket Umrah",
      sub: "Pilih paket perjalanan suci yang paling sesuai dengan kebutuhan Anda dan keluarga.",
      all: "Semua Paket",
      umrah: "Umrah",
      haji: "Haji",
      empty: "Tidak ada paket pada kategori ini.",
      search: "Cari paket, ustadz, hotel, maskapai...",
      filterTier: "Kategori",
      filterMonth: "Bulan",
      filterAirline: "Maskapai",
      filterAirport: "Bandara",
      filterPriceRange: "Rentang Harga",
      allTiers: "Semua Kategori",
      allMonths: "Semua Bulan",
      allAirlines: "Semua Maskapai",
      allAirports: "Semua Bandara",
      allPrices: "Semua Harga",
      resultsFound: "paket ditemukan",
      resetFilters: "Reset Filter",
      priceBudget: "Budget (< Rp 30jt)",
      priceStandard: "Standard (Rp 30jt – 39jt)",
      pricePremium: "Premium (Rp 40jt – 59jt)",
      priceLuxury: "Luxury (≥ Rp 60jt)",
    },
    booking: {
      title: "Formulir Pendaftaran",
      sub: "Isi formulir di bawah, tim kami akan menghubungi Anda dalam 1x24 jam.",
      name: "Nama Lengkap",
      email: "Alamat Email",
      phone: "Nomor WhatsApp",
      pax: "Jumlah Jamaah",
      pref: "Preferensi Keberangkatan",
      notes: "Catatan Tambahan",
      submit: "Kirim Pendaftaran",
      success: "Terima kasih! Tim kami akan menghubungi Anda segera.",
      error: "Maaf, terjadi kesalahan. Silakan coba lagi.",
    },
    contact: {
      title: "Hubungi Kami",
      sub: "Punya pertanyaan? Tim kami siap membantu Anda merencanakan perjalanan ibadah yang istimewa.",
      formTitle: "Kirim Pesan",
      name: "Nama",
      email: "Email",
      phone: "Nomor Telepon",
      subject: "Subjek",
      message: "Pesan Anda",
      success: "Pesan terkirim! Kami akan segera menghubungi Anda.",
      error: "Gagal mengirim pesan. Silakan coba lagi.",
      infoTitle: "Informasi Kontak",
      address: "Alamat Kantor",
      hours: "Jam Operasional",
      hoursVal: "Senin – Sabtu, 09.00 – 17.00 WIB",
      social: "Ikuti Kami",
    },
    gallery: {
      title: "Galeri Perjalanan Suci",
      sub: "Momen-momen berharga dari ribuan jamaah BATIK Tour & Travel.",
    },
    blog: {
      title: "Cerita & Panduan",
      sub: "Wawasan, panduan, dan kisah seputar umrah dan haji.",
      by: "Oleh",
    },
    footer: {
      bigtitle: "Mari Wujudkan Mimpi ke Tanah Suci",
      bigsub: "Hubungi kami untuk konsultasi gratis seputar paket umrah dan haji.",
      tagline: "Mendampingi langkah suci Anda menuju Baitullah dengan amanah dan profesional.",
      explore: "Jelajahi",
      contactInfo: "Kontak",
      legal: "Legal",
      rights: "Hak Cipta Dilindungi.",
      privacy: "Kebijakan Privasi",
      terms: "Syarat & Ketentuan",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      packages: "Packages",
      gallery: "Gallery",
      blog: "Blog",
      contact: "Contact",
      book: "Book Now",
    },
    common: {
      readMore: "Read more",
      learnMore: "Learn more",
      viewAll: "View all",
      viewDetails: "View details",
      bookNow: "Book Now",
      send: "Send Message",
      sending: "Sending...",
      whatsapp: "Chat on WhatsApp",
      from: "From",
      duration: "Duration",
      departure: "Departure",
      inclusions: "Inclusions",
      highlights: "Package Highlights",
      backToPackages: "← Back to all packages",
      backToBlog: "← Back to blog",
    },
    hero: {
      overline: "A Meaningful Sacred Journey",
      titleA: "Perform Your",
      titleB: "Umrah & Hajj",
      titleC: "with a Tranquil Heart",
      sub: "BATIK Tour & Travel walks beside you with complete service, premium hotels next to Masjid al-Haram & Masjid an-Nabawi, and experienced ustadz spiritual guides.",
      cta1: "Explore Packages",
      cta2: "Free Consultation",
      stat1: "Year Established",
      stat2: "Pilgrims Sent",
      stat3: "Certified Guides",
      stat4: "Satisfaction Rate",
    },
    sections: {
      featuredOver: "Curated Selection",
      featuredTitle: "Featured Travel Packages",
      featuredSub: "Carefully designed umrah and hajj packages for a deeply devotional journey.",
      aboutOver: "About Us",
      aboutTitle: "Serving the Guests of Allah",
      aboutSub: "Since 2016, PT Baitullah Tiga Kharisma (BATIK Tour & Travel) has guided pilgrims with trust — officially licensed as PPIU & PIHK by Indonesia's Religious Ministry.",
      whyOver: "Why BATIK",
      whyTitle: "Our Commitment to You",
      testiOver: "Pilgrim Voices",
      testiTitle: "Stories of the Guests of Allah",
      testiSub: "The trust of thousands reflects the quality of our service.",
      galleryOver: "Travel Gallery",
      galleryTitle: "Sacred Moments Captured",
      gallerySub: "Every journey holds an unforgettable spiritual story.",
      blogOver: "Stories & Guides",
      blogTitle: "Latest Articles",
      blogSub: "Guides, tips, and inspiring stories about umrah and hajj.",
      ctaOver: "Ready to Depart?",
      ctaTitle: "Begin Your Spiritual Journey Today",
      ctaSub: "Our team is ready to help you find the perfect umrah or hajj package for you and your family.",
    },
    categories: {
      overline: "Our Services",
      title: "Packages That Suit Your Needs",
      sub: "Choose the worship service that best fits you and your family.",
    },
    fasilitas: {
      overline: "Pilgrim Facilities",
      title: "Umrah Package Facilities",
      sub: "Every package includes complete facilities so you can focus on worship with peace of mind.",
    },
    ustadz: {
      overline: "Spiritual Guides",
      title: "Ustadz Batik Travel",
      sub: "Experienced ustadz guiding our pilgrims throughout the Holy Land.",
    },
    why: {
      f1: "Official & Licensed",
      f1d: "Officially registered as a Umrah Travel Organizer (PPIU) by the Indonesian Religious Ministry.",
      f2: "Experienced Guides",
      f2d: "Certified ustadz with over 10 years of experience guiding pilgrims.",
      f3: "Premium Hotels",
      f3d: "Star-rated hotels with the closest locations to Masjid al-Haram and Masjid an-Nabawi.",
      f4: "Transparent Pricing",
      f4d: "No hidden fees — every facility is clearly listed in the contract.",
    },
    about: {
      hero: "Guiding Meaningful, Heartfelt Journeys of Worship",
      heroSub: "PT Baitullah Tiga Kharisma (BATIK Tour & Travel) — an officially licensed Umrah & Hajj agent (PPIU & PIHK) by Indonesia's Religious Ministry.",
      storyTitle: "Our Story",
      story1: "PT Baitullah Tiga Kharisma, known as BATIK Tour & Travel, is an official Umrah and Hajj agent founded in 2016 as a Travel Bureau. In 2020 we obtained official PPIU permit via KMA RI Decree No. U.565/2020 (No. 91205097027470003), and in 2023 we obtained PIHK permit (No. 91205097027470005) — accredited A by Indonesia's Religious Ministry.",
      story2: "We believe that a pilgrimage is a journey of the heart and soul. Our service doesn't end at departure — it continues through guidance, peace of mind, and a more meaningful worship experience.",
      story3: "Supported by professionals, experienced ustadz guides, and a transparent service system, BATIK is your worship partner — Safe, Comfortable, and In Accordance with Sunnah.",
      missionTitle: "Vision & Mission",
      visionTitle: "Vision",
      visionText: "To be a trusted Umrah and Hajj travel agent delivering every Indonesian Muslim to Baitullah with professional, trustworthy, and shariah-compliant service.",
      missionT: "Mission",
      mission1: "Offer official legality and a transparent departure flow",
      mission2: "Deliver comfort from registration through return",
      mission3: "Guide pilgrims to worship according to the Sunnah of the Prophet ﷺ",
      mission4: "Channel part of our earnings to da'wah and social causes",
      valuesTitle: "Our Values",
      v1: "Safe",
      v1d: "Official legality, clear departure flow, and support from the moment of registration.",
      v2: "Comfortable",
      v2d: "Effortless service — from package info and administration to on-ground assistance in the Holy Land.",
      v3: "Sunnah-Aligned",
      v3d: "Worship guidance so pilgrims can perform Umrah & Hajj according to the Sunnah of the Prophet ﷺ.",
      v4: "Blessed",
      v4d: "Part of our earnings is channeled to Islamic education, da'wah, and social causes.",
    },
    packages: {
      title: "Umrah Packages",
      sub: "Choose the sacred travel package that best fits you and your family.",
      all: "All Packages",
      umrah: "Umrah",
      haji: "Hajj",
      empty: "No packages in this category.",
      search: "Search packages, ustadz, hotel, airline...",
      filterTier: "Tier",
      filterMonth: "Month",
      filterAirline: "Airline",
      filterAirport: "Airport",
      filterPriceRange: "Price Range",
      allTiers: "All Tiers",
      allMonths: "All Months",
      allAirlines: "All Airlines",
      allAirports: "All Airports",
      allPrices: "All Prices",
      resultsFound: "packages found",
      resetFilters: "Reset Filters",
      priceBudget: "Budget (< IDR 30M)",
      priceStandard: "Standard (IDR 30M – 39M)",
      pricePremium: "Premium (IDR 40M – 59M)",
      priceLuxury: "Luxury (≥ IDR 60M)",
    },
    booking: {
      title: "Booking Form",
      sub: "Fill out the form below — our team will reach out within 24 hours.",
      name: "Full Name",
      email: "Email Address",
      phone: "WhatsApp Number",
      pax: "Number of Pilgrims",
      pref: "Departure Preference",
      notes: "Additional Notes",
      submit: "Submit Booking",
      success: "Thank you! Our team will contact you shortly.",
      error: "Sorry, something went wrong. Please try again.",
    },
    contact: {
      title: "Contact Us",
      sub: "Have a question? Our team is ready to help you plan an extraordinary spiritual journey.",
      formTitle: "Send a Message",
      name: "Name",
      email: "Email",
      phone: "Phone Number",
      subject: "Subject",
      message: "Your Message",
      success: "Message sent! We'll get back to you shortly.",
      error: "Failed to send message. Please try again.",
      infoTitle: "Contact Information",
      address: "Office Address",
      hours: "Operating Hours",
      hoursVal: "Mon – Sat, 09:00 – 17:00 WIB",
      social: "Follow Us",
    },
    gallery: {
      title: "Sacred Journey Gallery",
      sub: "Precious moments from thousands of BATIK pilgrims.",
    },
    blog: {
      title: "Stories & Guides",
      sub: "Insights, guides, and stories about umrah and hajj.",
      by: "By",
    },
    footer: {
      bigtitle: "Let's Make Your Holy Land Dream Real",
      bigsub: "Contact us for a free consultation on umrah and hajj packages.",
      tagline: "Walking beside your sacred steps to Baitullah with trust and professionalism.",
      explore: "Explore",
      contactInfo: "Contact",
      legal: "Legal",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
    },
  },
};
